import { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import {
  FLOATING_CHAT_BUTTON_BOTTOM_DEFAULT,
  setFloatingChatButtonBottom,
} from "./messagingSlice";

export const useFloatingChatButtonBottom = (bottom: number | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (bottom == null) {
      return;
    }

    dispatch(setFloatingChatButtonBottom(bottom));
    return () => {
      dispatch(
        setFloatingChatButtonBottom(FLOATING_CHAT_BUTTON_BOTTOM_DEFAULT),
      );
    };
  }, [bottom, dispatch]);
};
